import React, { useEffect, useState } from 'react'
import styles from './ProfileCompletionForm.module.css'
import {
    Box,
    CircularProgress,
    Grid,
    InputAdornment,
    Typography,
} from '@mui/material'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import {
    EmptyProfileWizardState,
    ProfileWizardAction,
    UpdateProfileAction,
} from '../../Store/Actions/ProfileAction'
import { addAddress } from '../../Store/Actions/AddressActions'
import useAlert from '../../Hooks/useAlert/useAlert'
import InputBox from '../../Components/InputBox/InputBox'
import {
    ButtonCmp,
    DropDownCmp,
    InputCmp,
    WhiteButtonCmp,
} from '../../Components'
import { useNavigate } from 'react-router-dom'
import { validation } from '../../Config'

const typeOptions = [
    { label: 'Shipping', value: 'Shipping' },
    // { label: 'General', value: 'General' },
    { label: 'Billing', value: 'Billing' },
    { label: 'PickUp', value: 'PickUp' },
]
const InsuranceForm = ({
    setWhichForm,
    setBarPercent,
    setInsuranceComplete,
    profileDetails,
}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { setAlert } = useAlert()
    const { profileWizarddata } = useSelector(
        (state) => state.ProfielWizardReducer
    )
    const docAndRegistrationValidation = validation.docAndRegistrationValidation

    const [gliStatus, setGliStatus] = useState(true)
    const [workersComp, setWorkersComp] = useState(true)

    const { control, handleSubmit, watch, setValue } = useForm({
        mode: 'onChange',
        defaultValues: {
            licensedProfession: '',
            licenseNumber: '',
            FEIN: '',
            bonded: 'NO',
            generalLiabilityInsurance: 'NO',
            gliPolicy: null,
            gliPolicyMax: '',
            workersComp: 'NO',
            wcPolicy: null,
            wcPolicyMax: '',
            businessDescription: '',
            affiliations: '',
            multiStates: [],
            gliAgentPhoneNumber: '',
            gliAgentStreetAddress: '',
            gliInsuranceCompanyName: '',
            gliAgentBusinessName: '',
            gliAgentLastName: '',
            gliAgentFirstName: '',
            wcAgentPhoneNumber: '',
            wcAgentStreetAddress: '',
            wcInsuranceCompanyName: '',
            wcAgentBusinessName: '',
            wcAgentLastName: '',
            wcAgentFirstName: '',
        },
        resolver: yupResolver(docAndRegistrationValidation),
    })

    const gliState = watch('generalLiabilityInsurance')
    const workersCompState = watch('workersComp')

    useEffect(() => {
        if (gliState) {
            console.log('gliState', gliState)
            if (gliState === 'NO') {
                setGliStatus(true)
                setValue('gliPolicy', null)
                setValue('gliPolicyMax', '')
            } else {
                setGliStatus(false)
            }
        }
    }, [gliState])

    useEffect(() => {
        if (workersCompState) {
            if (workersCompState === 'NO') {
                setWorkersComp(true)
                setValue('wcPolicy', null)
                setValue('wcPolicyMax', '')
            } else {
                setWorkersComp(false)
            }
        }
    }, [workersCompState])

    const onSubmit = (data) => {
        dispatch(ProfileWizardAction(data, 'insuranceInfo', setAlert))
        // dispatch(UpdateProfileAction(data, 'insuranceInfo', setAlert))
        // setWhichForm('socialMedia')
        // setBarPercent(`${(100 / 6) * 5}%`)
        // setAddressComplete(true)
    }
    useEffect(() => {
        if (profileWizarddata) {
            setWhichForm('socialMedia')
            setBarPercent(`${(100 / 5) * 4}%`)
            setInsuranceComplete(true)
            dispatch(EmptyProfileWizardState())
        }
    }, [profileWizarddata])
    return (
        <section className={styles.profileInfo}>
            <div>
                <Typography noWrap variant="h5" fontWeight={'bold'}>
                    Insurance Information
                </Typography>
            </div>
            <Box sx={{ my: '30px' }}>
                <Typography fontSize="16px" sx={{ color: 'var(--textColor)' }}>
                    Account Email{' '}
                    <span className="MuiFormLabel-asterisk">*</span>
                </Typography>
                <Typography fontSize="18px" sx={{ mt: '5px' }}>
                    {profileDetails.email
                        ? profileDetails.email
                        : 'taimoorjohn@hotmail.com'}
                </Typography>
            </Box>
            <form onSubmit={handleSubmit(onSubmit)}>
                <section className={styles.profile_doc_reg}>
                    <div className={styles.detailsBoxes}>
                        <section>
                            <DropDownCmp
                                name="bonded" //imporant
                                control={control} //imporant
                                label="Insured"
                                options={['YES', 'NO']}
                                disableClearable
                                freeSolo={false}
                                required
                            />
                        </section>
                        <section>
                            <DropDownCmp
                                name="generalLiabilityInsurance" //imporant
                                control={control} //imporant
                                label="General Liability Insurance"
                                options={['YES', 'NO']}
                                disableClearable
                                freeSolo={false}
                                required
                            />
                            {gliState === 'YES' && (
                                <>
                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="gliAgentFirstName" //imporant
                                            control={control} //imporant
                                            label="Agent First Name"
                                            disabled={gliStatus}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="gliAgentLastName" //imporant
                                            control={control} //imporant
                                            label="Agent Last Name"
                                            disabled={gliStatus}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="gliAgentBusinessName" //imporant
                                            control={control} //imporant
                                            label="Agent Business Name"
                                            disabled={gliStatus}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="gliInsuranceCompanyName" //imporant
                                            control={control} //imporant
                                            label="Insurance Company Name"
                                            disabled={gliStatus}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="gliAgentStreetAddress" //imporant
                                            control={control} //imporant
                                            label="Street Address"
                                            disabled={gliStatus}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="gliAgentPhoneNumber" //imporant
                                            control={control} //imporant
                                            type={'tel'}
                                            label="Phone Number"
                                            disabled={gliStatus}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="gliPolicy" //imporant
                                            control={control} //imporant
                                            label="Policy #"
                                            disabled={gliStatus}
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="gliPolicyMax" //imporant
                                            control={control} //imporant
                                            label="Policy Maximum"
                                            disabled={gliStatus}
                                            type="number"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>
                                </>
                            )}
                        </section>
                        <section>
                            <DropDownCmp
                                name="workersComp" //imporant
                                control={control} //imporant
                                label="Worker's Comp?"
                                options={['YES', 'NO']}
                                disableClearable
                                freeSolo={false}
                                required
                            />
                            {workersCompState === 'YES' && (
                                <>
                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="wcAgentFirstName" //imporant
                                            control={control} //imporant
                                            label="Agent First Name"
                                            disabled={workersComp}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="wcAgentLastName" //imporant
                                            control={control} //imporant
                                            label="Agent Last Name"
                                            disabled={workersComp}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="wcAgentBusinessName" //imporant
                                            control={control} //imporant
                                            label="Agent Business Name"
                                            disabled={workersComp}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="wcInsuranceCompanyName" //imporant
                                            control={control} //imporant
                                            label="Insurance Company Name"
                                            disabled={workersComp}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="wcAgentStreetAddress" //imporant
                                            control={control} //imporant
                                            label="Street Address"
                                            disabled={workersComp}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="wcAgentPhoneNumber" //imporant
                                            control={control} //imporant
                                            type={'tel'}
                                            label="Phone Number"
                                            disabled={workersComp}
                                            // requiredAsterisk={true}
                                            required
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="wcPolicy" //imporant
                                            control={control} //imporant
                                            label="Policy #"
                                            disabled={workersComp}
                                        />
                                    </Box>

                                    <Box sx={{ mt: '15px' }}>
                                        <InputCmp
                                            name="wcPolicyMax" //imporant
                                            control={control} //imporant
                                            label="Policy Maximum"
                                            disabled={workersComp}
                                            type="number"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        $
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>
                                </>
                            )}
                        </section>
                    </div>
                </section>
                {/* ////btn */}
                <section className={styles.formBtns}>
                    {/* <WhiteButtonCmp title="Cancel" /> */}
                    {/* <WhiteButtonCmp
                        title="Cancel"
                        onClick={() => {
                            navigate('/profile')
                        }}
                    /> */}
                    <ButtonCmp
                        title="Skip Step"
                        onClick={() => {
                            setWhichForm('socialMedia')
                        }}
                    />
                    <ButtonCmp
                        title="Save and Continue"
                        type="submit"
                        // onClick={() => {
                        //   onSubmit();
                        // }}
                    />
                </section>
            </form>
        </section>
    )
}

export default InsuranceForm
